import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import "./coverflow.css";

import { EffectCoverflow, Pagination } from "swiper";

function Coverflow(props) {
  const Data=props.data;
 
  return (
    <>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
      >
          {Data.map((image,id)=>{
          return(
            image.Mix.map((img,id)=>{
              return (

                <SwiperSlide id={id}>
              
              <img src={img.url} alt={img.name} />
      
            </SwiperSlide>
            )
            })
            
            )
            
          })}
      </Swiper>
    </>
  );
}
export default Coverflow;